import styled from '@emotion/styled';
import { Box, Dialog, Grid, IconButton, Typography } from '@mui/material';
import Image from 'next/image';
import { YellowButton } from '@/components/button/button';
import { CloseIcon } from '@/components/icons/icons';
import Momenteer from '@/components/layout/primary-layout/components/welcome-modal/assets/CuriousAboutCurikoMomenteer.png';
import { config } from '@/config/environment';
import { nextImageTransitionProps } from '@/constants/next-image-transition-props';
import useIsMobile from '@/hooks/use-is-mobile';
import { useScheduleWelcomeModalOpen } from '../hooks/use-schedule-welcome-modal-open/use-schedule-welcome-modal-open';
// imageprops without the src, alt, width, and height props

const StyledTitle = styled(Typography)`
  color: #000;
  font-family: var(--font-cooper-light);
  font-size: 68px;
  font-style: normal;
  font-weight: 400;
  line-height: 108.3%; /* 75.81px */
`;
const StyledSubtext = styled(Typography)`
  color: #1e1e1e;
  font-family: var(--font-work-sans), sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.44px;
`;

const StyledMobileTitle = styled(Typography)`
  color: #000;
  font-family: var(--font-cooper-light);
  font-size: 35px;
  font-style: normal;
  text-align: center;
  font-weight: 400;
  line-height: 108.3%; /* 75.81px */
`;
const StyledMobileSubtext = styled(Typography)`
  color: #1e1e1e;
  font-family: var(--font-work-sans), sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.44px;
`;

export function ScheduleWelcomeModal() {
  const { scheduleWelcomeModalOpen, setScheduleWelcomeModalOpen } = useScheduleWelcomeModalOpen();
  const { isMobile } = useIsMobile();
  const handleClose = () => {
    setScheduleWelcomeModalOpen(false);
  };

  return (
    <Dialog
      open={scheduleWelcomeModalOpen}
      onClose={handleClose}
      fullWidth
      maxWidth={'lg'}
      scroll="body"
      PaperProps={{
        style: {
          overflow: 'hidden',
          position: 'relative',
        },
      }}
    >
      <IconButton
        style={{ position: 'absolute', top: 10, right: 10, zIndex: 99 }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>

      <Box px={4} style={{ position: 'relative', zIndex: 10 }}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={6}
            style={{ display: 'flex', justifyContent: 'center', paddingLeft: '50px' }}
          >
            <Box
              pb={4}
              pt={isMobile ? 8 : 2}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: 20,
                height: '100%',
                width: '100%',
                maxWidth: 320,
              }}
            >
              {isMobile ? (
                <StyledMobileTitle>Want to book this experience?</StyledMobileTitle>
              ) : (
                <StyledTitle>Want to book this experience?</StyledTitle>
              )}
              {isMobile ? (
                <>
                  <StyledMobileSubtext>
                    Unlock access to in-person experiences by meeting with a Curiko team member!
                  </StyledMobileSubtext>
                  <StyledMobileSubtext>Schedule a 30 minute chat.</StyledMobileSubtext>
                </>
              ) : (
                <>
                  <StyledSubtext>
                    Unlock access to in-person experiences by meeting with a Curiko team member!
                  </StyledSubtext>
                  <StyledSubtext>Schedule a 30 minute chat.</StyledSubtext>
                </>
              )}

              <div>
                <YellowButton
                  fullWidth={false}
                  onClick={() => {
                    handleClose();
                    window.open(config.calendly.welcome, '_blank');
                  }}
                >
                  Schedule a welcome
                </YellowButton>
              </div>
            </Box>
          </Grid>
          {!isMobile && (
            <Grid item xs={12} sm={6}>
              <Image {...nextImageTransitionProps} src={Momenteer} alt=""></Image>
            </Grid>
          )}
        </Grid>
      </Box>
    </Dialog>
  );
}
